require.register("picture/controllers/newCtrl", function(exports, require, module){
  $0
  
});

